import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import TextInput from "src/components/TextInput";
import { ActiveStrengthExerciseDropSet, ActiveStrengthExerciseSet, useEndActiveWorkoutSetMutation } from "src/graphql";
import { rangeUnitToString } from "../utils/range-unit-to-string";
import { CheckCircle as CheckIcon } from 'react-huge-icons/solid'

const ActiveDropsetExercise = (props: {
    ds: ActiveStrengthExerciseDropSet, dsidx: number, workoutExerciseId: string,
    registerWeight: any
    registerReps: any
}) => {

    const { t } = useTranslation();
    const { ds, dsidx, registerReps, registerWeight } = props;

    return <div className="space-y-2">
        <h2>דרופ סט {dsidx + 1}</h2>
        {ds.reps && <div className='gap-2 items-center flex'>
            <div className="basis-1/2 flex flex-col">
                <p className='light'>
                    {t("reps")}
                </p>
                <div>
                    {rangeUnitToString(ds.reps, t)}
                </div>
            </div>
            <span>עשיתי:</span>
            <TextInput inputProps={registerReps} type="number" maxLength={3} value={String(ds?.reps?.done || ds?.reps?.val)} />
        </div>}
        {ds.weight && <div className='gap-2 items-center flex'>
            <div className="flex flex-col basis-1/2">
                <p className='light'>
                    {t("weight")}
                </p>
                <span>
                    {rangeUnitToString(ds.weight, t)}
                </span>
            </div>
            {!['body', 'max'].includes(ds.weight?.unit || "") &&
                <>
                    <span>עשיתי:</span>
                    <TextInput inputProps={registerWeight} type="number" maxLength={3} value={String(ds?.weight?.done || ds?.weight?.val)} />
                </>
            }
        </div>}
    </div>

}

export default ActiveDropsetExercise